/***/
class GaCollapsible extends HTMLElement {
  constructor() {
    super();
    this.sectionTitle = this.querySelectorAll('.section-title');
    if(this.sectionTitle){
      this.sectionTitle.forEach((item) => {
        item.addEventListener('click', this.toggle.bind(this));
      })
    }
  }

  toggle(e) {
    const target = e.target;
    const content = target.closest('div.section');
    console.log(content);
    content.classList.toggle('active');
  }


}
customElements.define('ga-collapsible', GaCollapsible);